/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import AppConfig from "../core/config/AppConfig";

const base_src = AppConfig.base_api_url;
export const ApiSrc = {
    LIST_RECEIVER: `${base_src}/receiver/list`,
    RECEIVER_DETAIL: `${base_src}/receiver/detail`,
    CREATE_RECEIVER: `${base_src}/receiver/create`,
    UPDATE_RECEIVER: `${base_src}/receiver/update`,
    UPDATE_RECEIVER_WAREHOUSE_ACCOUNT_NO: `${base_src}/receiver/update-warehouse-account-no`,

    // way bi l l
    LIST_WAYBILL: `${base_src}/waybill/list`,
    DETAIL_WAYBILL: `${base_src}/waybill/detail`,
    CREATE_WAYBILL: `${base_src}/waybill/create`,
    UPDATE_WAYBILL: `${base_src}/waybill/update`,
    DELETE_WAYBILL: `${base_src}/waybill/delete`,
    LIST_WAYBILL_LOG: `${base_src}/waybill/log/list`,

    LOGIN: `${base_src}/oauth/token`,
    GET_USER_INFO: `${base_src}/system/user/info`,
    GET_USER_LIST: `${base_src}/system/user/list`,
    CREATE_USER: `${base_src}/system/user/create`,
    UPDATE_USER_INFO: `${base_src}/system/user/update`,

    // statistic
    GET_WAYBILL_STATISTIC: `${base_src}/statistic/waybill`,
    GET_USER_STATISTIC: `${base_src}/statistic/user`,
    GET_WALLET_STATISTIC: `${base_src}/statistic/wallet`,

    GET_USER_WAREHOUSE: `${base_src}/warehouse/user/warehouse`,

    // SEtting
    GET_SETTING: `${base_src}/system/setting`,

    // Bundle 
    CREATE_BUNDLE: `${base_src}/bundle/create`,
    REFUND_BUNDLE: `${base_src}/bundle/refund`,
    GET_BUNDLE_LIST: `${base_src}/bundle/list`,
    GET_BUNDLE_DETAIL: `${base_src}/bundle/detail`,    
    GET_BUNDLE_LOG_LIST: `${base_src}/bundle/log/list`,
    UPDATE_BUNDLE_STATUS: `${base_src}/bundle/status/update`,        
    

    // Balance
    GET_BALANCE_LIST: `${base_src}/balance/transaction/list`,
    GET_BALANCE_DETAIL: `${base_src}/balance/detail`,

}